import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-12 px-4 bg-brand-dark relative z-10" data-id="element-195">
      <div className="max-w-3xl mx-auto text-center" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-danger/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_30px_rgba(239,68,68,0.1)]" data-id="element-197">
          <p className="text-xs font-black tracking-widest text-brand-danger uppercase mb-3" data-id="element-198">
            Il vero costo della preparazione manuale
          </p>
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-5" data-id="element-199">
            Quanto tempo stai perdendo, davvero?
          </h2>
          <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-3" data-id="element-200">
            Preparare manualmente ogni lezione, ogni UDA e ogni scheda ti toglie
            in media da{' '}
            <span className="text-brand-danger font-bold" data-id="element-201">
              4 a 6 ore a settimana
            </span>
            .
          </p>
          <p className="text-base sm:text-lg text-gray-400 leading-relaxed" data-id="element-202">
            Più di{' '}
            <span className="text-brand-danger font-bold" data-id="element-203">
              200 ore durante l'anno scolastico
            </span>
            . Ogni anno. Per sempre.
          </p>
        </motion.div>
      </div>
    </section>;
}